<template>
  <div id="login-container" :class="webnamefinal">
    <Navigationbar v-if="!isInIframe" :webname="webnamefinal"> </Navigationbar>
    <b-loading
      v-if="isLoading"
      :is-full-page="true"
      :active="isLoading"
    ></b-loading>
    <div id="content-frame" v-else>
      <div id="content-inner">
        <div id="content-logo">
          <img :src="logourl" class="top-logo" />
        </div>
        <div id="login-step1" class="">
          <div id="main-part">
            <div id="" class="" v-if="!done">
              <h2>
                ACCESO
              </h2>
              <p class="primary-text has-text-centered">
                {{ texts.login.intro_text }}
              </p>

              <div class="login-forms-container onlyline-field">
                <b-field
                  label="Introduce tu dirección de email y te enviaremos un mensaje para reiniciar tu contraseña"
                  :type="type_email"
                  :message="msg_email"
                >
                  <b-icon
                    class="onlyline-icon"
                    pack="mdi"
                    icon="email-outline"
                    size="is-small"
                  >
                  </b-icon>
                  <b-input
                    ref="emailField"
                    type="email"
                    class="onlyline"
                    placeholder="email"
                    v-model="inputs.email"
                    @keydown.native.enter="handleEnterKey"
                    required
                    expanded
                  >
                  </b-input>
                </b-field>
              </div>
              <div class="login-button-container">
                <a
                  class="login-button button is-fullwidth is-primary"
                  :class="classLoading"
                  @click="resetPassword(inputs)"
                  id="login-button"
                >
                  <span style="width:1.5em;"> </span>
                  <span>Reiniciar contraseña</span>
                  <span class="icon">
                    <i class="fa fa-arrow-right"></i>
                  </span>
                </a>
              </div>

              <router-link class="button is-fullwidth" :to="{ name: 'login' }"
                >Volver</router-link
              >
            </div>
            <div v-else style="margin-top:20vh">
              <h2>
                ¡Hecho!. Mira tu buzón de email y pulsa en el link que te hemos
                enviado para reestablecer tu contraseña.
                <router-link :to="{ name: 'login' }"
                  >Volver a login</router-link
                >
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footerbar v-if="!isInIframe && isLoading == false"> </Footerbar>
  </div>
</template>
<script>
//import { mapState } from 'vuex'
import Navigationbar from '@/components/UI/Navigationbar.vue'
import Footerbar from '@/components/UI/Footerbar.vue'
import { RegisterStepMixin } from '@/components/mixins/RegisterStepMixin'
import { ToolsMixin } from '@/components/mixins/ToolsMixin'
import { topLevelPageMixin } from '@/components/mixins/topLevelPageMixin'

export default {
  name: 'ResetPassword',
  components: {
    Navigationbar,
    Footerbar
  },
  props: {
    webname: {
      type: String,
      default: ''
    },
    env: {
      type: String,
      default: 'PRO'
    }
  },
  mixins: [topLevelPageMixin, RegisterStepMixin, ToolsMixin],

  data: () => ({
    done: false,
    inputs: {
      email: ''
    },
    msg_email: '',
    type_email: '',
    isLoading: true
  }),
  methods: {
    resetPassword({ email }) {
      this.isLoading = true
      if (this.ifFormValid() == false) {
        this.isLoading = false
        return
      }
      this.$store
        .dispatch('auth/resetPassword', email)
        .then(() => {
          this.done = true
          this.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.isLoading = false
          this.type_email = 'is-danger'
          this.msg_email = error.response.data[0]
        })

      //this.$parent.close()
    },
    ifFormValid() {
      var isValid = this.$refs.emailField.checkHtml5Validity()
      return isValid
    },
    handleEnterKey() {
      this.resetPassword(this.inputs)
      this.$refs.emailField.$el.firstElementChild.blur()
    }
  },
  computed: {
    logourl: function() {
      return process.env.BASE_URL + this.webnamefinal + '/logo.png'
    },
    texts: function() {
      return this.$store.state.decoupled.configFile.texts
    },
    classLoading: function() {
      if (this.isLoading == true) return 'is-loading'
      else return ''
    },
    isInIframe: function() {
      return window.location != window.parent.location ? true : false
    }
  },
  created() {
    console.log('on created')
    this.retrieveConfigFilesAndInit()
  }
}
</script>
<style lang="css">
/* only if it is embeded within the home */
#home-container input.input {
  border-bottom: 1px solid #ffffff;
  background-color: transparent !important;
  color: white;
}

#home-container .login-button {
  background-color: white;
}
#login-forms-container {
  wdith: 100%;
}

.login-button-container {
  text-align: center;
  padding: 40px 0;
}
.login-button {
  width: 100%;
  height: 52px;
  font-size: 22px;
  font-weight: 300;
  justify-content: space-between;
}
.onlyline input {
  padding: 0px;
  width: calc(100% - 10px);
}
#home-container .has-text-primary {
  color: white !important;
}
#login-button.is-loading span,
#login-button.is-loading span i {
  color: white;
}

.resetpwd-inner {
  margin: auto;
  width: 100vw;
  max-width: 450px;
  min-height: 100vh;
  position: inherit;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

#resetpwd-card {
  background-color: #fff;
  padding: 32px;
  padding-top: 16px;
  padding-bottom: 64px;
  border: 1px solid #9cafb7;
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  flex: 1;
  display: flex;
  max-height: 800px;
}
</style>
